import { useCallback, useState } from "react";

export const useToggle = (initialValue: boolean | (() => boolean)): [boolean, () => void] => {
    const [state, setState] = useState(initialValue);

    const toggleState = useCallback(() => {
        setState((currentState) => !currentState);
    }, []);

    return [state, toggleState];
};
